import { useEffect, useRef } from "react"
import { useNavigate, useLocation } from "react-router-dom"

export default function SessionWatcher({ logoutUser }) {
  const navigate = useNavigate()
  const location = useLocation()
  const checkingRef = useRef(false)

  useEffect(() => {
    const publicRoutes = ["/login", "/system/recover-password", "/system/update-password"]

    const checkSession = async () => {
      if (publicRoutes.includes(location.pathname)) return
      if (localStorage.getItem("is_logged_in") !== "true") return
      if (checkingRef.current) return

      checkingRef.current = true

      try {
        const res = await fetch("/sistema/get-user-info/", {
          method: "GET",
          credentials: "include"
        })

        if (res.status === 401) {
          logoutUser()
          navigate("/login", { replace: true })
        }
      } catch {
      } finally {
        checkingRef.current = false
      }
    }

    const interval = setInterval(checkSession, 1800000)

    return () => clearInterval(interval)
  }, [logoutUser, navigate, location.pathname])

  return null
}